module.exports = __webpack_public_path__ + "static/media/linkedin-icon.62ef9d19.svg";